<template>
  <b-container fluid>
    <b-row>
      <b-col xl="12" lg="12" sm="12">
        <iq-card>
          <template v-slot:body>
            <b-row>
              <b-col xl="12" lg="12" sm="12">
                <ValidationObserver ref="form1"  v-slot="{ handleSubmit, reset }">
                  <b-form  @submit.prevent="handleSubmit(searchData)" @reset.prevent="reset" enctype="multipart/form-data">
                    <b-row>
                         <b-col lg="6" sm="12" md="4">
                            <ValidationProvider name="Fiscal Year" vid="fiscal_year_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="fiscal_year_id "
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                    {{$t('globalTrans.fiscal_year')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="search.fiscal_year_id"
                                    id="fiscal_year_id"
                                    :options="fiscalYearList"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                        {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="12">
                            <ValidationProvider name="Organization" vid="org_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="organiation_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('globalTrans.organization')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="search.org_id"
                                    :options="orgList"
                                    id="organiation_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="12">
                            <ValidationProvider name="Institute Type" vid="office_type_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="office_type_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('child_configuration.institute_type')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="search.office_type_id"
                                    :options="officeTypeList"
                                    id="office_type_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col lg="6" sm="12">
                            <ValidationProvider name="Institute Name" vid="office_id" rules="required|min_value:1">
                                <b-form-group
                                    class="row"
                                    label-cols-sm="5"
                                    label-for="office_id"
                                    slot-scope="{ valid, errors }"
                                    >
                                    <template v-slot:label>
                                        {{$t('child_configuration.institute_name')}} <span class="text-danger">*</span>
                                    </template>
                                    <b-form-select
                                    plain
                                    v-model="search.office_id"
                                    :options="officeList"
                                    id="office_id"
                                    :state="errors[0] ? false : (valid ? true : null)"
                                    >
                                    <template v-slot:first>
                                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                                    </template>
                                    </b-form-select>
                                    <div class="invalid-feedback">
                                    {{ errors[0] }}
                                    </div>
                                </b-form-group>
                            </ValidationProvider>
                        </b-col>
                        <b-col>
                          <div class="text-right">
                            <b-button type="submit" variant="primary">{{ $t('globalTrans.search')}}</b-button>
                          </div>
                        </b-col>
                    </b-row>
                  </b-form>
                </ValidationObserver>
                    <br>
                <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
                    <b-form @submit.prevent="handleSubmit(saveData)" @reset.prevent="reset" enctype="multipart/form-data">
                      <b-overlay :show="unitLoad">
                        <b-row>
                          <b-col xl="12" lg="12" sm="12">
                            <b-table-simple bordered>
                              <thead class="bg-primary">
                                  <tr>
                                      <th class="text-center" width="100px">{{ $t('globalTrans.sl_no') }}</th>
                                      <th scope="col">{{ $t('child_admission_management.registration_id') }}</th>
                                      <th scope="col">{{ $t('child_admission_management.name') }}</th>
                                      <th scope="col">{{ $t('child_admission_management.student_type') }}</th>
                                      <th class="text-center" scope="col">{{ $t('globalTrans.select') }}</th>
                                  </tr>
                              </thead>
                              <b-tbody>
                                  <b-tr v-for="(item, index) in meeting.list" :key="index">
                                      <b-td class="text-center">{{ $n(index + 1) }}</b-td>
                                      <b-td>{{ item.registration_id }}</b-td>
                                      <b-td>{{ (currentLocale === 'bn') ? item.name_bn : item.name }}</b-td>
                                      <b-td>{{ getStudentType(item.student_type) }}</b-td>
                                      <b-td>
                                        <b-form-group
                                          style="margin-bottom: 0rem"
                                          class="text-center"
                                        >
                                          <b-form-checkbox
                                              :id="'is_same-' + index"
                                              v-model="item.checked"
                                              name="checkbox-1"
                                              value="1"
                                              unchecked-value="0"
                                          >
                                          </b-form-checkbox>
                                        </b-form-group>
                                      </b-td>
                                  </b-tr>
                                  <b-tr v-if="nodata">
                                      <td colspan="5" class="text-center">
                                        <span class="text-black">{{ (currentLocale === 'bn') ? 'কোন তথ্য পাওয়া যায়নি!' : 'No Data Found' }}</span>
                                      </td>
                                  </b-tr>
                              </b-tbody>
                            </b-table-simple>
                          </b-col>
                        </b-row>
                        <div class="row">
                          <div class="col-sm-3"></div>
                          <div class="col text-right">
                            <b-button type="submit" variant="primary" class="mr-2">{{ saveBtnName }}</b-button>
                            &nbsp;
                            <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-4')">{{ $t('globalTrans.cancel') }}</b-button>
                          </div>
                        </div>
                      </b-overlay>
                  </b-form>
                </ValidationObserver>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import RestApi, { childServiceBaseUrl } from '@/config/api_config'
import { onlineAdmissionDataApi, assignToRehabilitationStoreApi } from '../../api/routes'
import flatpickr from 'flatpickr'
import { isNotEmpty } from '@amcharts/amcharts4/.internal/core/utils/Utils'

export default {
  props: ['id'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
      search: {
        fiscal_year_id: 0,
        org_id: 0,
        office_type_id: 0,
        office_id: 0,
        is_rehabilitated: 1
      },
      meeting: {},
      nodata: true,
      unitLoad: false,
      officeTypeList: [],
      officeList: []
    }
  },
  computed: {
    fiscalYearList: function () {
        return this.$store.state.commonObj.fiscalYearList.filter(item => item.status === 0)
    },
    orgList: function () {
      return this.$store.state.commonObj.organizationProfileList.filter(item => item.status === 0)
    },
    currentLocale () {
      return this.$i18n.locale
    }
  },
  created () {
    if (this.id) {
      const tmp = this.getcircularData()
      // Object.freeze(tmp)
      this.institute = tmp
    }
      this.search.org_id = this.$store.state.dataFilters.orgId
      this.search.office_type_id = this.$store.state.dataFilters.officeTypeId
      this.search.office_id = this.$store.state.dataFilters.officeId
  },
  mounted () {
    flatpickr('#meeting_date', {})
  },
  watch: {
    'search.org_id': function (newVal, oldVal) {
       this.getOfficeTypeList()
    },
    'search.office_type_id': function (newVal, oldVal) {
       this.getOfficeList()
    }
  },
  methods: {
    searchData () {
      this.unitLoad = true
      RestApi.getData(childServiceBaseUrl, onlineAdmissionDataApi, this.search).then(response => {
          if (response.success) {
            if (isNotEmpty(response.data)) {
              this.nodata = false
              this.meeting.list = this.getRelationalData(response.data)
            } else {
              this.meeting.list = null
              this.nodata = true
            }
          }
          this.unitLoad = false
      })
    },
    getRelationalData (data) {
      const listData = data.map(item => {
          return Object.assign({}, item, { checked: '1' })
      })
      return listData
    },
    getOfficeTypeList () {
        this.officeTypeList = this.$store.state.commonObj.officeTypeList.filter(item => item.status === 0 && item.org_id === this.search.org_id && [15, 53, 28, 16, 18, 22, 17, 25, 24, 43, 52, 51, 44, 23, 31, 54, 49, 13, 55, 47, 46, 50, 48, 19, 21, 3].includes(item.value)).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getOfficeList () {
        this.officeList = this.$store.state.commonObj.officeList.filter(item => item.status === 0 && item.office_type_id === this.search.office_type_id).map(obj => {
            if (this.$i18n.locale === 'bn') {
                return { value: obj.value, text: obj.text_bn }
            } else {
                return { value: obj.value, text: obj.text_en }
            }
        })
    },
    getStudentType (typeId) {
        const Type = this.$store.state.ChildService.commonObj.studentTypeList.find(type => type.value === typeId)
        if (this.$i18n.locale === 'bn') {
            return Type.text_bn
        } else {
            return Type.text_en
        }
    },
    getcircularData () {
      const tmpData = this.$store.state.list.find(item => item.id === this.id)
      return JSON.parse(JSON.stringify(tmpData))
    },
    async saveData () {
      this.unitLoad = true
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      let result = null
      const loadingState = { loading: false, listReload: false }

      result = await RestApi.postData(childServiceBaseUrl, assignToRehabilitationStoreApi, this.meeting)
      loadingState.listReload = true

      this.$store.dispatch('mutateCommonProperties', loadingState)
      if (result.success) {
        if (result.notification && this.$store.state.emitNotification) {
            const notification = result.notification
            this.$socket.emit('send-notification', notification)
        }
        this.$toast.success({
          title: this.$t('globalTrans.success'),
          message: this.id ? this.$t('globalTrans.update_msg') : this.$t('globalTrans.save_msg'),
          color: '#D6E09B'
        })
        this.unitLoad = false
        this.$bvModal.hide('modal-4')
      } else {
        this.unitLoad = false
        this.$toast.error({
            title: this.$t('globalTrans.error'),
            message: result.message,
            color: '#D6E09B'
        })
        this.$refs.form.setErrors(result.errors)
      }
    }
  }
}
</script>
